/* Carrousels met pijlen.
 *
 * Werkt op elke [data-hl-carousel] met een [data-hl-track] erin. De baan is
 * een gewone scroll-container met scroll snapping, dus zonder dit script kun
 * je nog steeds vegen of scrollen; de pijlen zijn een toevoeging, geen
 * voorwaarde. Er is bewust geen slider-bibliotheek gebruikt.
 */
(function () {
  function step(track) {
    var card = track.firstElementChild;
    if (!card) return track.clientWidth;
    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function updateArrows(root, track) {
    var prev = root.querySelector('[data-hl-prev]');
    var next = root.querySelector('[data-hl-next]');
    // 2px marge: browsers ronden scrollLeft af, waardoor het einde net niet
    // exact gelijk is aan scrollWidth min clientWidth.
    var atStart = track.scrollLeft <= 2;
    var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    if (prev) prev.disabled = atStart;
    if (next) next.disabled = atEnd;
    root.classList.toggle('is-static', atStart && atEnd);
  }

  function init(root) {
    var track = root.querySelector('[data-hl-track]');
    if (!track) return;

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-hl-prev], [data-hl-next]');
      if (!btn) return;
      var dir = btn.hasAttribute('data-hl-next') ? 1 : -1;
      track.scrollBy({ left: dir * step(track), behavior: 'smooth' });
    });

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(function () { updateArrows(root, track); });
    }, { passive: true });

    window.addEventListener('resize', function () { updateArrows(root, track); });
    updateArrows(root, track);
  }

  function boot() {
    document.querySelectorAll('[data-hl-carousel]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* Telbadge op het winkelwagenicoon (V26, 02-09-2026).
 *
 * Impulse zet alleen een stip aan of uit; de referentie toont het aantal.
 * Na elke wijziging van de winkelwagen (Impulse stuurt daar events voor, en
 * de cart-apps roepen /cart/*.js aan) wordt het aantal opnieuw uit /cart.js
 * gelezen. De badge zelf is een span [data-hl-cart-count] in
 * snippets/header-icons.liquid.
 */
(function () {
  var timer = null;

  function apply(count) {
    document.querySelectorAll('[data-hl-cart-count]').forEach(function (el) {
      el.textContent = count;
      var bubble = el.closest('.cart-link__bubble');
      if (bubble) bubble.classList.toggle('cart-link__bubble--visible', count > 0);
    });
  }

  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { if (cart && typeof cart.item_count === 'number') apply(cart.item_count); })
        .catch(function () {});
    }, 400);
  }

  ['ajaxProduct:added', 'cart:updated', 'cart:build', 'cart:open', 'cart:close'].forEach(function (name) {
    document.addEventListener(name, refresh);
  });

  // Ook cart-apps (UpCart, Swatch King) praten via fetch met /cart/…; dat is
  // het moment om opnieuw te tellen.
  try {
    var origFetch = window.fetch;
    if (origFetch && !origFetch.__hlCart) {
      var patched = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var p = origFetch.apply(this, arguments);
        if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(refresh, function () {});
        return p;
      };
      patched.__hlCart = true;
      window.fetch = patched;
    }
  } catch (e) {}

  document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
})();
